import {
  useCart,
  CartCheckoutButton,
  Link,
  Image,
  CartProvider,
} from '@shopify/hydrogen';
import {Dialog} from '@headlessui/react';

import {useCartUI} from './CartUIProvider.client';
import CartIconWithItems from './CartIconWithItems.client';
import {BUTTON_PRIMARY_CLASSES} from './Button.client';
import SpinnerIcon from './SpinnerIcon.client';
import noImage from './../assets/image/default-book-image-not-found.png';
import {useEffect, useState} from 'react';
import {API_INTERNAL_URL, API_INTERNAL_TOKEN_CLUBHLM} from '../config';
import {GLOBAL_VARS} from '../lib/globalvars';


/**
 * A client component that contains the merchandise that a customer intends to purchase, and the estimated cost associated with the cart
 */
export default function Cart({customerAccessToken, customer}) {
  const {isCartOpen, closeCart} = useCartUI();
  const [cartKey, setCartKey] = useState('');
  const {status, checkoutUrl, lines, id, cost, discountCodesUpdate} = useCart();
  const [checkCartRedirect, setCheckCartRedirect] = useState(false);
  const [open, setOpen] = useState(false);
  const [authCLubHLM, setAuthCLubHLM] = useState({});
  const [isClubHLM, setIsClubHLM] = useState(false);
  const [clubHLMDiscount, setClubHLMDiscount] = useState('');

  const getClubHLMDiscount = async () => {
    return new Promise(async (resolve, reject) => {
      if (!customer) return;
      const customerId = customer?.customer?.id;
      const csId = customerId.split('/')[4];
      const cartId = id ? id : '';
      const crId = cartId ? cartId.split('/')[4] : '';

      const response = await fetch(`${API_INTERNAL_URL}club/discountcode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_INTERNAL_TOKEN_CLUBHLM}`,
        },
        body: JSON.stringify({
          email: customer.customer.email,
          customer_id: parseInt(csId),
          cart_id: crId,
          amount: parseFloat(cost?.totalAmount.amount),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          reject(error);
        });
      localStorage.setItem('authClubHLMUser', JSON.stringify(response));
      resolve(response);
    });
  };

  const init = async (discountCodesUpdate, id) => {
    const clubhlm = await getClubHLMDiscount();
    
    if (clubhlm.code) {

      const hasSetClubHLM = localStorage.getItem('hasSetClubHLM')
      ? localStorage.getItem('hasSetClubHLM')
      : false;

      if(!hasSetClubHLM){
        discountCodesUpdate([clubhlm.code]);
        localStorage.setItem('hasSetClubHLM', true);
      //  window.location.reload();
      }

      setTimeout(() => {
        setCartKey(Math.random());
        setClubHLMDiscount(clubhlm.code);
        discountCodesUpdate([clubhlm.code]);       
      }, 2000);
    }
    
    const localAuthCLubHLM = localStorage.getItem('authClubHLMUser')
      ? JSON.parse(localStorage.getItem('authClubHLMUser'))
      : {};
    setAuthCLubHLM(localAuthCLubHLM);
  };
  useEffect(() => {
    init(discountCodesUpdate, id);
  }, []);

  useEffect(() => {
    if (authCLubHLM?.code) {
      setIsClubHLM(true);
    }
  }, [authCLubHLM]);

  useEffect(() => {
    const checkCartRedirectStorage = localStorage.getItem(
      'hasEbookFromCartLoginRedirect',
    );
    if (checkCartRedirectStorage) {
      setCheckCartRedirect(true);
    }
  }, []);

  useEffect(() => {
    if (isCartOpen) {
      init( discountCodesUpdate, id);
    }
  }, [isCartOpen]);

  useEffect(() => {
    if (checkCartRedirect) {
      if (checkoutUrl) {
        if (checkoutUrl.includes('http') && lines.length > 0) {
          localStorage.removeItem('hasEbookFromCartLoginRedirect');
          window.location.href = checkoutUrl;
        }
      }
    }
  }, [status]);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className={`z-20 fixed top-0 bottom-0 left-0 right-0 bg-black transition-opacity duration-400 ${
          isCartOpen ? 'opacity-20' : 'opacity-0 hidden pointer-events-none'
        }`}
        onClick={isCartOpen ? closeCart : null}
      />
      <Dialog open={isCartOpen} onClose={closeCart}>
        <Dialog.Overlay className="bg-overlay fixed z-30 inset-0" />
        <CartProvider key={cartKey}>
          <CartBody
            key={cartKey}
            customer={customer}
            customerAccessToken={customerAccessToken}
            isClubHLM={isClubHLM}
            discountCodes={clubHLMDiscount}
          ></CartBody>
        </CartProvider>
      </Dialog>
    </>
  );
}

function CartBody({customerAccessToken, isClubHLM, discountCodes, customer }) {
  const {totalQuantity, status, discountCodesUpdate} = useCart();

  useEffect(() => {
    discountCodesUpdate([discountCodes]);
  }
  , [discountCodes]);

  return (
    <>
      {status != 'fetching' && status != 'updating' ? (
        <div
          className={`cart-popup bg-white absolute flex flex-col md:block z-20 left-0 right-0 bottom-0 h-full md:left-auto md:bottom-auto md:h-auto md:max-h-[calc(100vh-56px)] w-full md:w-[549px] rounded-b-lg shadow-2xl
          ${totalQuantity === 0 ? 'overflow-hidden' : 'overflow-y-scroll'}
          ${scroll ? 'stick' : ''}`}
        >
          <CartHeader />
          {totalQuantity === 0 ? (
            <CartEmpty />
          ) : (
            <>
              <CartItem
                customer={customer}
                customerAccessToken={customerAccessToken}
                isClubHLM={isClubHLM}
              />
            </>
          )}
        </div>
      ) : (
        <div
          className={`cart-popup bg-white absolute flex flex-col md:block z-20 left-0 right-0 bottom-0 h-full md:left-auto md:bottom-auto md:h-auto md:max-h-[calc(100vh-56px)] w-full md:w-[549px] rounded-b-lg shadow-2xl
          ${scroll ? 'stick' : ''}`}
        >
          <div className="relative h-full flex justify-center">
            <SpinnerIcon />
          </div>
        </div>
      )}
    </>
  );
}
function CartItemFooter({item, customerAccessToken, isItemEbook, isClubHLM, customer}) {
  const {closeCart, isCartOpen} = useCartUI();
  const {checkoutUrl} = useCart();
  const [isEbook, setIsEbook] = useState(false);
  const all = useCart();
  const checkIfIsEbook = async (merchandise) => {
    const data = await fetch(
      `https://ellibrero.myshopify.com/api/2021-04/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-shopify-storefront-access-token':'08d65afd1c45cce28156c380662775c7',
        },
        body: JSON.stringify({
          query: QUERY_PRODUCT,
          variables: {
            id: merchandise.product.id,
          },
        }),
      },
    )
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          return res.body.json();
        }
      })
      .catch((error) => {
        return {
          error: error.toString(),
        };
      });

    const checkedIfEbook =
      data?.data?.product?.productType.toLowerCase() == 'ebooks' ? true : false;
    if (!customerAccessToken) {
      if (checkedIfEbook) {
        localStorage.setItem('hasEbookFromCartNotLogin', true);
        localStorage.setItem(
          'hasEbookFromCartNotLoginCheckoutURL',
          checkoutUrl,
        );
      }
    }
    return checkedIfEbook;
  };

  const QUERY_PRODUCT = `
query Product($id: ID!) {
  product(id: $id) {
    id
    title
    handle
    description
    descriptionHtml
    productType
    vendor
    tags
  }
}
`;

  const getCoupon = () => {
    const discountCodes = all?.discountCodes ? all?.discountCodes : [];
    let coupon = '';

    if (discountCodes.length > 0) {
      coupon = discountCodes.map((item) => {
        return item.code;
      });

      return coupon.join(',');
    } else {
      return '';
    }
  };

  const CustomCheckoutButtonComponent = () => {
    const {closeCart} = useCartUI();
    const gotToCheckout = () => {
      let url = checkoutUrl;
      if (customer?.data) {
        url = `${cart.checkoutUrl}&checkout[email]=${customer.data.customer.email}`;

        if (customer.data.customer.addresses.edges[0].node.country) {
          url = `${url}&checkout[shipping_address][country]=MX`;
        }
        if (customer.data.customer.addresses.edges[0].node.firstName) {
          url = `${url}&checkout[shipping_address][first_name]=${customer.data.customer.addresses.edges[0].node.firstName}`;
        }

        if (customer.data.customer.addresses.edges[0].node.lastName) {
          url = `${url}&checkout[shipping_address][last_name]=${customer.data.customer.addresses.edges[0].node.lastName}`;
        }
        if (customer.data.customer.addresses.edges[0].node.phone) {
          url = `${url}&checkout[shipping_address][phone]=${customer.data.customer.addresses.edges[0].node.phone}`;
        }
        if (customer.data.customer.addresses.edges[0].node.address1) {
          url = `${url}&checkout[shipping_address][address1]=${customer.data.customer.addresses.edges[0].node.address1}`;
        }
        if (customer.data.customer.addresses.edges[0].node.city) {
          url = `${url}&checkout[shipping_address][city]=${customer.data.customer.addresses.edges[0].node.city}`;
        }
        if (customer.data.customer.addresses.edges[0].node.zip) {
          url = `${url}&checkout[shipping_address][zip]=${customer.data.customer.addresses.edges[0].node.zip}`;
        }
        if (customer.data.customer.addresses.edges[0].node.province) {
          url = `${url}&checkout[shipping_address][province]=${customer.data.customer.addresses.edges[0].node.province}`;
        }
        if (customer.data.customer.addresses.edges[0].node.company) {
          url = `${url}&checkout[shipping_address][company]=${customer.data.customer.addresses.edges[0].node.company}`;
        }
      }
      url = `${url}&checkout[shipping_address][country]=MX`;

      window.location.href = url;
    };

    return (
      <div className="px-0 py-2 mx-auto flex justify-center">
        <button
          onClick={closeCart}
          className={`btn-main buyButton bg-purple-120 px-5 py-3 border rounded-full text-white w-full '
            } `}
        >
          Seguir comprando
        </button>
      </div>
    );
  };

  const handleBeginCheckoutDataLayer = () => {
    dataLayer.push({
      event: 'begin_checkout', //Static data
      currency: item.cost.totalAmount.currencyCode, //Dynamic data
      value: item.cost.totalAmount.amount, //Dynamic data
      item_id: item.id, //Dynamic data
      item_name: item.merchandise.product.title, //Dynamic data
      affiliation: 'Google Merchandise Store', //Dynamic data
      discount: getCoupon(), //Dynamic data
      index: '0', //Dynamic data
      price: item.cost.totalAmount.amount, //Dynamic data
      quantity: item.quantity, //Dynamic data
    });
  };

  const defineLinkButtonPay = ()=>{
    if(!localStorage.getItem('druid_user_id')){ 
      return loginDruId();
    }
  }

  useEffect(() => {
    const buyButton = document.querySelector('.buyButton');
    if (buyButton) {
      buyButton.addEventListener('click', () => {
        handleBeginCheckoutDataLayer();
      });
    }
  }, [isCartOpen]);

  useEffect(() => {
    checkIfIsEbook(item.merchandise).then((res) => {
      setIsEbook(res);
      isItemEbook(res);
    });
  }, [item]);

  return (
    <>
      <div className="flex flex-col w-full mt-4 py-4 border-b border-t">
        <div className="flex justify-between items-end mb-3">
          <p>
            Subtotal:{' '}
            <span className="text-light-purple">
              ({item.quantity} artículos)
            </span>
          </p>
          <p className="cart-subtotal text-right text-red-40 font-semibold text-3xl ">
            {item.cost.totalAmount.currencyCode} {item.cost.totalAmount.amount}
          </p>
        </div>
        <div className="hidden flex justify-between items-end">
          <p>Costo estimado de envio:</p>
          <p className="cart-subtotal text-right text-red-40 font-semibold text-3xl ">
            Free
          </p>
        </div>
      </div>
      <div
        className={`flex items-center ${
          isClubHLM ? 'justify-center' : 'justify-between'
        } mt-5 w-full gap-3 xs:flex-col buttons-payment`}
      >
        {!customerAccessToken && isEbook ? (
          <Link
            to={defineLinkButtonPay()}
            onClick={closeCart}
            className="btn-main bg-purple-120 rounded-full text-white"
          >
            Pagar
          </Link>
        ) : (
          <>
            {!isClubHLM && (
              <CustomCheckoutButtonComponent className="btn-main bg-purple-120 rounded-full text-white buyButton">
                Pagar
              </CustomCheckoutButtonComponent>
            )}
          </>
        )}
        <a
          href="/cart"
          className="btn-paynow btn-with-icon !h[39px] relative flex justify-between items-center p-3"
        >
          <div className='label-bag prod-version'>
            Ir a Mi Bolsa
            <div className="icon">
              <CartIconWithItems />
            </div>
          </div>
        </a>
      </div>
    </>
  );
}

function CartItem({customerAccessToken, isClubHLM, customer }) {
  const {lines} = useCart();
  const [isItemEbook, setIsItemEbook] = useState(false);

  const handleIsItemEbook = (isEbook) => {
    setIsItemEbook(isEbook);
  };

  return (
    <>
      {lines.map((item, index) => {
        if ((GLOBAL_VARS.CART.lastProductSelected === item.merchandise.id)) {
          return (
            <>
              <div
                key={item.merchandise.product.id}
                role="row"
                className="cart-item flex text-gray-900 px-5 pb-5 pt-10"
              >
                
                {item.merchandise.image?.url ? (
                  <div
                    role="cell"
                    className="flex-shrink-0 mr-7 xs:mr-3 relative"
                  >
                    <Link to={`/producto/${item.merchandise.product.handle}`}>
                      <Image
                        src={item.merchandise.image?.url+'&width=115&height=168&quality=99'}
                        className="bg-white border-black border-opacity-5"
                        width={115}
                        height={168}
                      />
                    </Link>
                    {isItemEbook && (
                      <div className="badge-ebook bg-purple-120">eBook</div>
                    )}
                  </div>
                ) : (
                  <div
                    role="cell"
                    className="flex-shrink-0 mr-7 xs:mr-3 relative"
                  >
                    <Link to={`/producto/${item.merchandise.product.handle}`}>
                      <Image
                        src={noImage}
                        className="bg-white border-black border-opacity-5"
                        width={115}
                        height={168}
                      />
                    </Link>
                    {isItemEbook && (
                      <div className="badge-ebook bg-purple-120">eBook</div>
                    )}
                  </div>
                )}

                <div
                  role="cell"
                  className="flex flex-col w-full justify-between items-start flex-grow-1 mr-4"
                >
                  <Link
                    to={`/producto/${item.merchandise.product.handle}`}
                    className="product-title hover:underline text-purple-120"
                  >
                    {item.merchandise.product.title}
                  </Link>
                  <CartItemFooter
                    item={item}
                    customerAccessToken={customerAccessToken}
                    isClubHLM={isClubHLM}
                    customer={customer}
                    isItemEbook={handleIsItemEbook}
                  />
                </div>
              </div>
            </>
          );
        }
      })}
    </>
  );
}

function CartHeader() {
  const {closeCart} = useCartUI();
  return (
    <button type="button" onClick={closeCart} className="closeCartPopup">
      <span className="sr-only">Close cart</span>
      <ArrowIcon />
    </button>
  );
}

function CartEmpty() {
  const {closeCart} = useCartUI();

  return (
    <div className="p-7 flex flex-col">
      <p className="mb-4 text-lg text-gray-500 text-center">
        Tu Bolsa este vacía
      </p>
      <button
        type="button"
        onClick={closeCart}
        className={BUTTON_PRIMARY_CLASSES}
      >
        Continuar comprando
      </button>
    </div>
  );
}

function ArrowIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.125 7.87501L10 10M10 10L7.875 12.125M10 10L12.125 12.125M10 10L7.875 7.87501M16.375 16.375C12.8542 19.8958 7.14581 19.8958 3.62499 16.375C0.104176 12.8542 0.104176 7.14582 3.62499 3.62501C7.14581 0.104187 12.8542 0.104187 16.375 3.62501C19.8958 7.14582 19.8958 12.8542 16.375 16.375Z"
        stroke="#5A66AD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
